// @flow

import client from "@api";
import { useCallback, useEffect, useState } from "react";

type hookParams = {
    method: "get" | "post",
    query: string,
    body?: any,
};

export default ({ method, query, body }: hookParams) => {
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string>("");
    const [data, setData] = useState(null);
    const [refetch, setRefetch] = useState<boolean>(true);

    const request = useCallback(() => {
        const statusValidation = {
            validateStatus: status => {
                return status >= 200 && status < 300;
            },
        };

        if (method === "get") {
            // $FlowFixMe
            return client().get(query, statusValidation);
        }
        // $FlowFixMe
        return client().post(query, body, statusValidation);
    }, [method, query, body]);

    useEffect(() => {
        refetch &&
            request()
                .then(({ data }) => {
                    setData(data);
                    setLoading(false);
                    setRefetch(false);
                })
                .catch(error => {
                    setError(error);
                    setLoading(false);
                    setRefetch(false);
                });
    }, [request, refetch]);

    return [loading, data, error, () => setRefetch(true)];
};
